import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { compose, lifecycle } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { NavLink } from 'react-router-dom';


import Logo from './Logo';
import ProfileMenu from './ProfileMenu';
import { commonStyles, COLORS } from '../styles/styles';
import {selectedProgram, selectedModule, getUserPrograms, selectedContent, getSelectedThinktool} from '../redux/selectors'

import avatar from '../assets/avatar.jpg';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import logoLong from '../assets/CPS_logo_long.png';
import logoShort from '../assets/icon_new.svg';
//  import logoLong from '../assets/futureshiftLong.png';
//  import logoShort from '../assets/futureShiftSmall.png';
// import logoLong from '../assets/iepaLogoLong.png';
// import logoShort from '../assets/ipeaLogo.png';
import AvatarCirce from './AvatarCircle';
import { authAdminRequest, authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';
import logoSmall from '../assets/logo.svg'
import { getUserProgramsFullRequest, selectUserPrograms, resetUserPrograms, selectUserModule, selectUserContent } from '../redux/reducers/userProgramsFull';
import {showMessageCenter} from '../redux/reducers/messagesList'

import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
  MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBContainer, MDBIcon, MDBBadge, MDBAnimation } from "mdbreact";
import authHOC from './AuthHOC';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { getSelectedContent } from '../utils';
import { setReturnItem, toggleRefererPage } from '../redux/reducers/view';
import supportIcon from '../assets/support_icon_white.svg'
import { dropdownsRequest } from '../redux/reducers/dropdowns';
import { STORAGE_LINK } from '../constants';
import { xapiRequest } from '../redux/reducers/xapi';



const checkPath = (location, selectUserPrograms, selectUserModule, selectUserContent, selectedContent) => {
  var paths = location.pathname.split('/');
  
  if(paths[1] && paths[1]=='content'){
    console.log('modulesx3')
    selectUserPrograms(parseInt(paths[2]))
    selectUserModule(parseInt(paths[3]));
  }
  if(paths[1] && paths[1]=='modules'){
    selectUserPrograms(parseInt(paths[2]))
  }
  if(paths[1] && paths[1]=='tools'){
    selectUserPrograms(parseInt(paths[2]))
  }
  if(paths[1] && paths[1]=='assessments'){
    selectUserPrograms(parseInt(paths[2]))
  }
  if(paths[1] && paths[1]=='versions'){
    selectUserPrograms(parseInt(paths[2]))
    selectUserContent(parseInt(paths[3]))
    if(selectedContent){
      
      selectUserModule(selectedContent.module_id);
    }
    
  }
}
  
  class Header extends Component {
    state = {
      collapseID: ""
    };
    
    
    toggleCollapse = collapseID => () =>
      this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    }));

    showMessageCenter() {
      
      this.props.showMessageCenter(true)
    }
    
    render() {
      const { classes} = this.props;
      return (
        
          <MDBNavbar color="default-color" dark expand="md" fixed="top">
            <MDBNavbarBrand>
            <div className="d-none d-md-block">
              <img className="longLogo" src={logoLong} />
            </div>
            <div className="d-block d-md-none">
            <img style={{height:42}} src={logoShort} />
            </div>
            </MDBNavbarBrand>
            
            <MDBNavbarToggler onClick={this.toggleCollapse("navbarCollapse3")} />
            <MDBCollapse id="navbarCollapse3" isOpen={this.state.collapseID} navbar>
              <MDBNavbarNav left>
                <MDBNavItem active>
                  <MDBNavLink to="/home">Home</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to="/chooseassessment">Assessments</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to="/choosetool">Tools</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to="/choosesession">Live Sessions</MDBNavLink>
                </MDBNavItem>
              </MDBNavbarNav>
            </MDBCollapse>

            <MDBNavbarNav className="userNav" right>
            <div onClick={()=>{
              try {
                window.zE('messenger', 'open');
                window.zE('messenger:set', 'zIndex', 10000);
              } catch (error) {
                
              }
            
              }}>
        <img src={supportIcon} style={{height: "160%",
    position: "absolute",
    left: -40
}} />
      </div>
                <MDBNavItem style={{width:45}}>
                  <MDBDropdown>
                    <MDBDropdownToggle className="dopdown-toggle" nav>
                      <div style={{position: 'relative'}}>
                        {this.props.loginReducer.user.avatar ? <img src={STORAGE_LINK+this.props.loginReducer.user.avatar} className="rounded-circle z-depth-0"
                          style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", padding: 0, position: 'absolute', zIndex: 1, top: -5}} alt="" />
                      : <img src={avatar} className="rounded-circle z-depth-0"
                      style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", padding: 0, position: 'absolute', zIndex: 1, top: -5}} alt="" />
                        }
                    </div>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-default" right>
                      <MDBDropdownItem href="#!">Deactivate Account</MDBDropdownItem>
                      <MDBDropdownItem onClick={ () => {
                          this.props.xapiRequest({xapiType: 'Logged Out'})
                        
                          setTimeout(() => {
                            this.props.logoutUserRequest(this.props.loginReducer.token)
                          }, 4000);
                         
                         // localStorage.setItem('firstShowTourPopup', false);
                        }}>Log out</MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>
                <MDBNavItem>
                  
                
                  {(this.props.loginReducer.user && this.props.loginReducer.user.numberOfUnreadMessages!=0) ? <MDBAnimation type="pulse" infinite>
                    <div className="mailBadgeHeader" onClick={this.showMessageCenter.bind(this)}>
                      <MDBIcon far icon="envelope" className="ml-1" size="lg" />
                     {(this.props.loginReducer.user && this.props.loginReducer.user.numberOfUnreadMessage!=0) && <MDBBadge className="badge-pill-round"  color="danger-color">{this.props.loginReducer.user && this.props.loginReducer.user.numberOfUnreadMessages}</MDBBadge>}
                    </div>
                    </MDBAnimation> : 
                    <div className="mailBadgeHeader" onClick={this.showMessageCenter.bind(this)}>
                      <MDBIcon far icon="envelope" className="ml-1" size="lg" />
                   </div>
                    }
                   
                 
                </MDBNavItem>
              </MDBNavbarNav>
          </MDBNavbar>
        );
      }
    }

const styles = theme => ({
  ...commonStyles,
  mainHeaderTitle: {
    marginRight: 30,
    marginLeft: 400,
    color: '#fff',
    fontWeight: theme.typography.fontWeightLight,
    fontSize: theme.typography.fontSize,
    letterSpacing: 0.5,
    textAlign: 'right',
    display: 'inline-block',
    paddingTop:10
  },
  mainHeader: {
    backgroundColor: '#8a272a',
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    height: 47,
  },
  toolbar: {
    minHeight: 35,
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 455,
  },
  mainHeaderNav: {
    width: '100%',
  },
  mainHeaderNavLink: {
    textTransform: 'uppercase',
    padding: '10px 0',
    textDecoration: 'none',
    color: '#fff',
    fontWeight: 240,
  },
  mainHeaderNavLinkActive: {
    fontWeight: 400,
  },
  mainHeaderNavTitle: {
    fontSize: '1rem',
    display: 'inline-block',
    padding: '16px 20px 0px 20px',
  },

});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  getProgram: selectedProgram(state),
  selectedContent: getSelectedThinktool(state),
  view: state.viewReducer,
  userProgramsFull: getUserPrograms(state),
});

const mapDispatchToProps = dispatch => ({
  showMessageCenter: bool => dispatch(showMessageCenter(bool)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  selectUserContent: moduleId => dispatch(selectUserContent(moduleId)),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
  setReturnItem: (item) => dispatch(setReturnItem(item)),
  xapiRequest: value => dispatch(xapiRequest(value)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  authHOC,
  lifecycle({
    componentWillMount(){
     console.log('authhoc test', this.props)
      checkPath(this.props.location, this.props.selectUserPrograms, this.props.selectUserModule,this.props.selectUserContent, this.props.selectedContent)
    
    },
  


   
  }

  ),
  withStyles(styles),
)(Header);

Header.propTypes = {
  classes: PropTypes.instanceOf(Object),
  loginReducer: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
};
